import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: var(--gap-width);
  width: 100%;

  #logoContainer,
  #linkContainer {
    flex: 1;
  }

  #logo {
    color: var(--font-main);
    display: flex;
  }

  #logo svg {
    height: 4rem;
  }

  #linkContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  #linkContainer a {
    color: var(--font-main);
    text-decoration: none;
    margin: 0;
  }

  #linkContainer a p {
    color: var(--font-main);
    margin: 0 0 8px 0;
    text-align: left;
    font-size: 0.875rem;
  }
`;

const Header = () => {
  return (
    <StyledHeader>
      <div id="logoContainer">
        <Link to="/" id="logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 969.54 316.12">
            <path
              d="M252.9,623.43c6.66,13.53,12.29,30.88,27.34,42.18,17.37,13.06,36.71,15.55,57,8.68,21.25-7.2,38.28-17.42,54.61-33.66-9.49-15.92-10.71-35.19-7.61-51.89,2.39-12.91,20.36-16.12,29.2-12.71,5.46,2.11,7.47,15.2,7.9,21.56,1.32,19.56-7.69,27.85-21.56,42.27,12.39,12.23,32.08,12.07,48.78,4.36,19.63-9.07,35-19.81,45.15-39.05a212.72,212.72,0,0,1,11.08-19c5.12-7.63,10.1-7.52,15.23,0,4.29,6.25,8.35,12.66,13,19.74,7.8-8.84,14.89-17.28,22.43-25.32S570.69,565,583,562c-16.15,19.49-29.23,35-46.54,48.47,16.21,16.65,28.87,31.17,43.22,45.93-4.92,1.17-3.56,5.92-18.88-10.75-7.54-8.21-19.52-20.56-28-30.4-10,14.91-19.31,26.8-27.83,41.54-5.37,9.3-9.87,18.69,1.67,27.4-6.26,2.25-11.46-.59-11.12-6.81.45-8.23.7-17.44,4.51-24.29,7.61-13.71,17.33-26.29,26.73-38.91,3-4,4-7,.53-10.66-6.08-6.43-12.35-10-17-19.41-4.49,7.42-6.25,10.93-9.15,16.62-11.08,21.76-26.29,39.63-49.18,49.13-18.77,7.78-37.49,8-54.82-6.42-15.88,14.09-40.05,29.24-60.38,36.45-33.86,12-63.35,1-80.24-31.54-3.61-7-4-16.43-8.07-24.48-5.62,4.22-21.45,15.15-26.25,17.88-10.54,6-11.63,5.19-22.77,9.81-6.19,2.56-10.69,1.06-13.58-8.35-11.25,47.68-22.53,94.85-13.68,145.83-6.95-5.58-7.87-8.32-8.17-14.25-1.84-36.11-6.07-36.94-.47-72.39,7-44.16,31.17-125.38,40.4-169.29,2.83-13.48,5.47-27,8.36-40.46.27-1.29,1.67-2.33,2.54-3.49l2.51.78c-1.53,8.49-3.36,36.85-5.22,45.27-6.9,31.35-13.42,42.85-20.83,75.93,23.84-24.8,41.42-23,58.53,5.08,4.72-4.22,9.37-8.24,13.87-12.42,17.41-16.17,31.5-32.78,43.1-53.84,6-10.86,9.53-22.41,8.1-35.09-2.29-20.23-12.05-27.31-30.16-30.87-47.55-7.92-114.79.52-149.58,54.5-4.53,7.59-11.52,20.41-14.94,28.66-.67,1.63-1.26,3.29-1.89,4.94-.83-.09-2.22-.48-3-.57a46.08,46.08,0,0,1,1.37-8.81c6.9-25,22.18-44.16,42.76-59,36.57-26.38,77.82-35.17,122-28.81,9.41,1.36,19.23,6.47,26.83,12.43,15.88,12.46,17.08,30,11.74,48.15s-15.49,34.14-27.93,48C279.82,597,266.23,609.08,252.9,623.43Zm-6.45-3.68c-2.78-4.15-3.29-7.63-6.7-10.51-10.79-9.1-24.34-10.26-35.7-2.82C192.53,614,188.28,629.29,190,642.9c.79,6.4,4.2,6.21,11,4.34C218.51,642.4,229.89,628,246.45,619.75ZM396,636.48c13.17-14.56,17.26-27.63,17.17-44.07,0-6.49-2.34-12.35-9.49-13.14s-9.29,5.66-10,10.68a187.34,187.34,0,0,0-1.8,29.85C391.94,625.18,394.2,628.63,396,636.48Z"
              transform="translate(-115.23 -472.95)"
              fill="currentColor"
            />
            <path
              d="M986.74,579.38c-6.78,8.38-9.24,19.63-16.39,27.68-14.58,16.42-35.85,26.5-57.91,30.5-19.71,3.56-45.87.34-55.84-18.81-3.63-7-3.86-18.9-7.7-25.76-4.74-8.47-8-8.71-14.52-1.37-5.69,6.42-5,13.48-9.36,21-5.9,10.06-15.07,22.21-21,32.22-1.58,2.64-6.23,3.05-8.93,5-1.44-3.18-3.9-3.1-4-6.33-.24-7.24.65-17.74,1.19-25.63-6,5.34-11.3,10.11-16.61,14.9-16.11,14.54-62.28,12.65-77,1.07-13.53-10.68-9.53-26.45-11.15-41.33-.26-2.32-.29-4.67-.55-9.14-2.59,3.67-4.69,5.56-5.43,7.88-5,15.72-11,28.33-21.36,40.3-6.46,7.45-20.23,13-29.41,17-4.72,2.06-10.23-.07-15.22-.67-3.92-.48-14.17-10.4-12.51-15.41,7.06-21.2,22.31-40.84,42-51.51,9.74-5.29,25.59-3.82,34.76,1.73l9.24-4.35c1,3.25,2.4,6.45,2.81,9.78.59,4.85,3.94,15.4,4.58,20.24,3.44,26.3,18.17,29.05,41.81,30.29,27.07,1.43,47-12.95,56.9-39.85,1.53-4.17,3-8.37,4.45-12.55l2.75.32c0,1.89,1.06,4,.78,5.87-2.35,15.76-5.66,31.27-8,47-.26,1.72.16,3.55,1.94,5.85,1.85-2.77,3.91-5.43,5.52-8.33,7.51-13.52,14.75-27.19,22.45-40.6a35.51,35.51,0,0,1,8.38-9.84c8.18-6.6,16.64-5,21.91,3.95a119.67,119.67,0,0,1,7.92,16.06c11.92,29.75,45,33.55,66.39,19.66-18.92-5-25.87-17.57-18.24-36.5a63.83,63.83,0,0,1,41.86-37.24c16.74-4.55,25.73,5.89,23.32,23-.4,2.81-1,5.58-.18,9,2.12-2.31,4-4.89,6.43-6.86,2-1.63,4.55-2.53,6.85-3.75,1.15,2.56,6.06,4.69,6.4,7.34,1.29,10.22,2.09,18.54,4.18,28.56,3.52,16.82,13.22,29.67,30.21,30.79A73.1,73.1,0,0,0,1075.34,629c2.4-1.5,5.23-2.33,7.86-3.47.53,1.08,1,2.15,1.57,3.23-7.76,3.84-15.34,8.13-23.33,11.41-13.8,5.68-28.29,5.75-42.29,1.49-21.25-6.46-27.55-21.78-28.89-43.25-.39-6.1-.06-12.25-.06-18.37Zm-69.36,27.48c-.42,10,3.33,14.55,13.2,13.79a36.55,36.55,0,0,0,16.54-5.4c15.28-10,22.84-25,24.89-42.88,1.23-10.76-3.54-14.94-14.6-13.22C940,561.85,918.18,587.87,917.38,606.86ZM629,645.43c3-1.67,9.41-4.43,14.93-8.41,13.67-9.87,21.24-24.47,28.35-39.18,1.71-3.54,3.66-10.16,2.19-11.38-3.07-2.55-8.5-3.72-12.68-3.2-17.26,2.12-46.12,34.6-46.84,51.89C614.62,644,616.07,645.52,629,645.43Z"
              transform="translate(-115.23 -472.95)"
              fill="currentColor"
            />
          </svg>
        </Link>
      </div>
      <div id="linkContainer">
        {/* <Link to="/colophon" className="link">
          <p>Colophon</p>
        </Link> */}
        <Link to="/pics" className="link">
          <p>Pics</p>
        </Link>
        {/* <Link to="/writing" className="link">
          <p>Writing</p>
        </Link> */}
      </div>
    </StyledHeader>
  );
};

export default Header;
